// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Tajawal:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles - الأنماط العامة */
/* Import Arabic Google Fonts - استيراد خطوط جوجل العربية */

/* Color Palette - لوحة الألوان */
:root {
  --bg-white: #FFFFFF;
  --primary-dark-blue: #1a365d;
  --primary-blue: #2c5282;
  --secondary-light-gold: #d4af37;
  --secondary-gold: #b8945f;
  --accent-blue: #3182ce;
  --accent-teal: #0d9488;
  --accent-sky: #38bdf8;
  --accent-navy: #1a365d;
  --accent-maritime: #0e7490;
  --text-dark-gray: #1a202c;
  --text-medium-gray: #4a5568;
  --button-medium-blue: #2563eb;
  --button-hover-blue: #1d4ed8;
  --footer-medium-gray: #4a5568;
  --section-light-gray: #f7fafc;
  --section-bg: #edf2f7;
  --success-green: #10b981;
  --warning-orange: #f59e0b;
  --border-light: #e2e8f0;
  --shadow-color: rgba(26, 54, 93, 0.15);
  --gradient-primary: linear-gradient(135deg, #1a365d 0%, #2c5282 50%, #2563eb 100%);
  --gradient-gold: linear-gradient(135deg, #d4af37 0%, #b8945f 100%);
  --gradient-maritime: linear-gradient(135deg, #1a365d 0%, #0e7490 55%, #38bdf8 100%);
  --motion-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --motion-fast: 0.28s;
  --motion-med: 0.55s;
}

/* Dark Mode - الوضع الداكن */
.dark-mode {
  --bg-white: #1a202c;
  --primary-dark-blue: #e2e8f0;
  --primary-blue: #cbd5e0;
  --text-dark-gray: #f7fafc;
  --text-medium-gray: #cbd5e0;
  --footer-medium-gray: #a0aec0;
  --section-light-gray: #2d3748;
  --section-bg: #1a202c;
  --border-light: #4a5568;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --gradient-primary: linear-gradient(135deg, #2c5282 0%, #3182ce 50%, #4299e1 100%);
  --gradient-gold: linear-gradient(135deg, #d4af37 0%, #f6ad55 100%);
}

.dark-mode body {
  background-color: var(--bg-white);
  color: var(--text-dark-gray);
}

/* Reset and Base Styles - إعادة تعيين والأنماط الأساسية */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Cairo', 'Tajawal', Arial, sans-serif;
  background-color: var(--bg-white);
  color: var(--text-dark-gray);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* تحسينات للموبايل */
  -webkit-tap-highlight-color: transparent;
  touch-action: pan-y;
  /* منع pull-to-refresh على Android */
  overscroll-behavior-y: contain;
  overscroll-behavior-x: none;
  -webkit-overflow-scrolling: touch;
  /* منع bounce effect على iOS */
  -webkit-overscroll-behavior: contain;
  /* منع انقسام الشاشة */
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* السماح بـ pull-to-refresh */
html {
  overscroll-behavior-x: none;
  -webkit-overscroll-behavior-x: none;
  touch-action: pan-y;
}

html[dir='rtl'] body {
  direction: rtl;
  text-align: right;
}

html[dir='ltr'] body {
  direction: ltr;
  text-align: left;
}

/* Container - الحاوية */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* تحسينات للموبايل - Touch targets */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }

  /* تحسين حجم الأزرار للمس */
  .btn {
    min-height: 44px;
    min-width: 44px;
    padding: 12px 24px;
  }

  /* تحسين حقول الإدخال */
  input, textarea, select {
    font-size: 16px !important; /* يمنع التكبير التلقائي في iOS */
    -webkit-appearance: none;
    border-radius: 8px;
  }
}

/* Typography - الطباعة */
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  color: var(--primary-dark-blue);
  margin-bottom: 1rem;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.5rem;
}

p {
  margin-bottom: 1rem;
  line-height: 1.8;
}

/* Links - الروابط */
a {
  text-decoration: none;
  color: inherit;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--button-medium-blue);
}

/* Buttons - الأزرار */
.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 5px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 1rem;
  font-family: inherit;
}

.btn-primary {
  background: var(--gradient-primary);
  color: var(--bg-white);
  box-shadow: 0 4px 15px var(--shadow-color);
}

.btn-primary:hover {
  background: var(--gradient-primary);
  filter: brightness(1.1);
  color: var(--bg-white);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--shadow-color);
}

.btn-secondary {
  background: var(--gradient-gold);
  color: var(--primary-dark-blue);
  box-shadow: 0 4px 15px rgba(201, 169, 97, 0.3);
}

.btn-secondary:hover {
  background: var(--gradient-gold);
  filter: brightness(1.1);
  color: var(--primary-dark-blue);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(201, 169, 97, 0.4);
}

/* Section Titles - عناوين الأقسام */
.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: var(--primary-dark-blue);
  margin-bottom: 3rem;
  position: relative;
  padding-bottom: 1rem;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 50%;
  transform: translateX(50%);
  width: 100px;
  height: 4px;
  background: var(--gradient-gold);
  border-radius: 2px;
  box-shadow: 0 0 12px rgba(212, 175, 55, 0.35);
}

.section-shell {
  position: relative;
}

.section-shell::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 12% 18%, rgba(56, 189, 248, 0.08), transparent 42%),
    radial-gradient(circle at 88% 78%, rgba(212, 175, 55, 0.08), transparent 40%);
  pointer-events: none;
}

.section-shell > .container {
  position: relative;
  z-index: 1;
}

.section-subtitle {
  text-align: center;
  color: var(--footer-medium-gray);
  font-size: 1.2rem;
  margin-bottom: 2rem;
  font-weight: 400;
}

.quote-subtitle {
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
}

.scroll-reveal {
  opacity: 0;
  transform: translateY(36px) rotateX(8deg) scale(0.98);
  transform-origin: center top;
  transition: opacity 0.75s var(--motion-ease), transform 0.75s var(--motion-ease);
  perspective: 1000px;
}

.scroll-reveal-visible {
  opacity: 1;
  transform: translateY(0) rotateX(0) scale(1);
}

@media (prefers-reduced-motion: reduce) {
  .scroll-reveal,
  .scroll-reveal-visible {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

.scroll-reveal-fade-up {
  opacity: 0;
  transform: translateY(36px);
}

.scroll-reveal-fade-scale {
  opacity: 0;
  transform: translateY(18px) scale(0.96);
}

.scroll-reveal-fade-up.scroll-reveal-visible,
.scroll-reveal-fade-scale.scroll-reveal-visible {
  opacity: 1;
  transform: none;
}

.stagger-item {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.55s var(--motion-ease), transform 0.55s var(--motion-ease);
}

.stagger-visible .stagger-item {
  opacity: 1;
  transform: none;
}

.interactive-lift {
  position: relative;
  overflow: hidden;
  transition: transform var(--motion-fast) var(--motion-ease), box-shadow var(--motion-fast) ease;
}

.interactive-lift::before {
  content: '';
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--gradient-gold);
  transform: scaleY(0.35);
  transform-origin: top;
  transition: transform var(--motion-med) var(--motion-ease);
}

.interactive-lift:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px var(--shadow-color);
}

.interactive-lift:hover::before {
  transform: scaleY(1);
}

.btn-shimmer {
  position: relative;
  overflow: hidden;
}

.btn-shimmer::after {
  content: '';
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.35), transparent);
  transform: skewX(-18deg);
}

.btn-shimmer.is-shimmering::after {
  animation: btnShimmerPass 1.1s var(--motion-ease) 1;
}

@keyframes btnShimmerPass {
  to {
    left: 140%;
  }
}

@keyframes floatSoft {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-7px);
  }
}

@keyframes pulseSoft {
  0%,
  100% {
    opacity: 0.55;
  }
  50% {
    opacity: 1;
  }
}

@keyframes goldPulse {
  0% {
    transform: scale(0.96);
    text-shadow: 0 0 0 rgba(212, 175, 55, 0);
  }
  40% {
    transform: scale(1.05);
    text-shadow: 0 0 18px rgba(212, 175, 55, 0.45);
  }
  100% {
    transform: scale(1);
    text-shadow: 0 0 0 rgba(212, 175, 55, 0);
  }
}

@keyframes waveDrift {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes underlineGrow {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  .scroll-reveal,
  .stagger-item,
  .interactive-lift,
  .btn-shimmer::after {
    transition: none !important;
    animation: none !important;
  }

  .scroll-reveal,
  .stagger-item {
    opacity: 1 !important;
    transform: none !important;
  }

  .btn-shimmer.is-shimmering::after,
  .hero-waves,
  .flip-card-icon,
  .flip-card-hint,
  .country-list-dot {
    animation: none !important;
  }
}

/* Responsive - التصميم المتجاوب */
@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.75rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .container {
    padding: 0 15px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC,2DAA2D;;AAG3D,iCAAiC;AACjC;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,sCAAsC;EACtC,kFAAkF;EAClF,kEAAkE;EAClE,mFAAmF;EACnF,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,kFAAkF;EAClF,kEAAkE;AACpE;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;EAClD,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA,uBAAuB;EACvB;IACE,0BAA0B,EAAE,iCAAiC;IAC7D,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;iFAE+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qDAAqD;EACrD,4BAA4B;EAC5B,gFAAgF;EAChF,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE;;IAEE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,gFAAgF;AAClF;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+FAA+F;AACjG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,MAAM;EACN,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;EACA;IACE,sBAAsB;IACtB,8CAA8C;EAChD;EACA;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;;;IAIE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;IAEE,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;;;;;IAKE,0BAA0B;EAC5B;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Global Styles - الأنماط العامة */\n/* Import Arabic Google Fonts - استيراد خطوط جوجل العربية */\n@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Tajawal:wght@300;400;500;700&display=swap');\n\n/* Color Palette - لوحة الألوان */\n:root {\n  --bg-white: #FFFFFF;\n  --primary-dark-blue: #1a365d;\n  --primary-blue: #2c5282;\n  --secondary-light-gold: #d4af37;\n  --secondary-gold: #b8945f;\n  --accent-blue: #3182ce;\n  --accent-teal: #0d9488;\n  --accent-sky: #38bdf8;\n  --accent-navy: #1a365d;\n  --accent-maritime: #0e7490;\n  --text-dark-gray: #1a202c;\n  --text-medium-gray: #4a5568;\n  --button-medium-blue: #2563eb;\n  --button-hover-blue: #1d4ed8;\n  --footer-medium-gray: #4a5568;\n  --section-light-gray: #f7fafc;\n  --section-bg: #edf2f7;\n  --success-green: #10b981;\n  --warning-orange: #f59e0b;\n  --border-light: #e2e8f0;\n  --shadow-color: rgba(26, 54, 93, 0.15);\n  --gradient-primary: linear-gradient(135deg, #1a365d 0%, #2c5282 50%, #2563eb 100%);\n  --gradient-gold: linear-gradient(135deg, #d4af37 0%, #b8945f 100%);\n  --gradient-maritime: linear-gradient(135deg, #1a365d 0%, #0e7490 55%, #38bdf8 100%);\n  --motion-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --motion-fast: 0.28s;\n  --motion-med: 0.55s;\n}\n\n/* Dark Mode - الوضع الداكن */\n.dark-mode {\n  --bg-white: #1a202c;\n  --primary-dark-blue: #e2e8f0;\n  --primary-blue: #cbd5e0;\n  --text-dark-gray: #f7fafc;\n  --text-medium-gray: #cbd5e0;\n  --footer-medium-gray: #a0aec0;\n  --section-light-gray: #2d3748;\n  --section-bg: #1a202c;\n  --border-light: #4a5568;\n  --shadow-color: rgba(0, 0, 0, 0.3);\n  --gradient-primary: linear-gradient(135deg, #2c5282 0%, #3182ce 50%, #4299e1 100%);\n  --gradient-gold: linear-gradient(135deg, #d4af37 0%, #f6ad55 100%);\n}\n\n.dark-mode body {\n  background-color: var(--bg-white);\n  color: var(--text-dark-gray);\n}\n\n/* Reset and Base Styles - إعادة تعيين والأنماط الأساسية */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: 'Cairo', 'Tajawal', Arial, sans-serif;\n  background-color: var(--bg-white);\n  color: var(--text-dark-gray);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* تحسينات للموبايل */\n  -webkit-tap-highlight-color: transparent;\n  touch-action: pan-y;\n  /* منع pull-to-refresh على Android */\n  overscroll-behavior-y: contain;\n  overscroll-behavior-x: none;\n  -webkit-overflow-scrolling: touch;\n  /* منع bounce effect على iOS */\n  -webkit-overscroll-behavior: contain;\n  /* منع انقسام الشاشة */\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n/* السماح بـ pull-to-refresh */\nhtml {\n  overscroll-behavior-x: none;\n  -webkit-overscroll-behavior-x: none;\n  touch-action: pan-y;\n}\n\nhtml[dir='rtl'] body {\n  direction: rtl;\n  text-align: right;\n}\n\nhtml[dir='ltr'] body {\n  direction: ltr;\n  text-align: left;\n}\n\n/* Container - الحاوية */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* تحسينات للموبايل - Touch targets */\n@media (max-width: 768px) {\n  .container {\n    padding: 0 15px;\n  }\n\n  /* تحسين حجم الأزرار للمس */\n  .btn {\n    min-height: 44px;\n    min-width: 44px;\n    padding: 12px 24px;\n  }\n\n  /* تحسين حقول الإدخال */\n  input, textarea, select {\n    font-size: 16px !important; /* يمنع التكبير التلقائي في iOS */\n    -webkit-appearance: none;\n    border-radius: 8px;\n  }\n}\n\n/* Typography - الطباعة */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  margin-bottom: 1rem;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.5rem;\n}\n\np {\n  margin-bottom: 1rem;\n  line-height: 1.8;\n}\n\n/* Links - الروابط */\na {\n  text-decoration: none;\n  color: inherit;\n  transition: color 0.3s ease;\n}\n\na:hover {\n  color: var(--button-medium-blue);\n}\n\n/* Buttons - الأزرار */\n.btn {\n  display: inline-block;\n  padding: 12px 30px;\n  border-radius: 5px;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  font-size: 1rem;\n  font-family: inherit;\n}\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: var(--bg-white);\n  box-shadow: 0 4px 15px var(--shadow-color);\n}\n\n.btn-primary:hover {\n  background: var(--gradient-primary);\n  filter: brightness(1.1);\n  color: var(--bg-white);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px var(--shadow-color);\n}\n\n.btn-secondary {\n  background: var(--gradient-gold);\n  color: var(--primary-dark-blue);\n  box-shadow: 0 4px 15px rgba(201, 169, 97, 0.3);\n}\n\n.btn-secondary:hover {\n  background: var(--gradient-gold);\n  filter: brightness(1.1);\n  color: var(--primary-dark-blue);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(201, 169, 97, 0.4);\n}\n\n/* Section Titles - عناوين الأقسام */\n.section-title {\n  text-align: center;\n  font-size: 2.5rem;\n  color: var(--primary-dark-blue);\n  margin-bottom: 3rem;\n  position: relative;\n  padding-bottom: 1rem;\n}\n\n.section-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 50%;\n  transform: translateX(50%);\n  width: 100px;\n  height: 4px;\n  background: var(--gradient-gold);\n  border-radius: 2px;\n  box-shadow: 0 0 12px rgba(212, 175, 55, 0.35);\n}\n\n.section-shell {\n  position: relative;\n}\n\n.section-shell::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    radial-gradient(circle at 12% 18%, rgba(56, 189, 248, 0.08), transparent 42%),\n    radial-gradient(circle at 88% 78%, rgba(212, 175, 55, 0.08), transparent 40%);\n  pointer-events: none;\n}\n\n.section-shell > .container {\n  position: relative;\n  z-index: 1;\n}\n\n.section-subtitle {\n  text-align: center;\n  color: var(--footer-medium-gray);\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  font-weight: 400;\n}\n\n.quote-subtitle {\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.6;\n}\n\n.scroll-reveal {\n  opacity: 0;\n  transform: translateY(36px) rotateX(8deg) scale(0.98);\n  transform-origin: center top;\n  transition: opacity 0.75s var(--motion-ease), transform 0.75s var(--motion-ease);\n  perspective: 1000px;\n}\n\n.scroll-reveal-visible {\n  opacity: 1;\n  transform: translateY(0) rotateX(0) scale(1);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .scroll-reveal,\n  .scroll-reveal-visible {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n}\n\n.scroll-reveal-fade-up {\n  opacity: 0;\n  transform: translateY(36px);\n}\n\n.scroll-reveal-fade-scale {\n  opacity: 0;\n  transform: translateY(18px) scale(0.96);\n}\n\n.scroll-reveal-fade-up.scroll-reveal-visible,\n.scroll-reveal-fade-scale.scroll-reveal-visible {\n  opacity: 1;\n  transform: none;\n}\n\n.stagger-item {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.55s var(--motion-ease), transform 0.55s var(--motion-ease);\n}\n\n.stagger-visible .stagger-item {\n  opacity: 1;\n  transform: none;\n}\n\n.interactive-lift {\n  position: relative;\n  overflow: hidden;\n  transition: transform var(--motion-fast) var(--motion-ease), box-shadow var(--motion-fast) ease;\n}\n\n.interactive-lift::before {\n  content: '';\n  position: absolute;\n  inset-inline-start: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--gradient-gold);\n  transform: scaleY(0.35);\n  transform-origin: top;\n  transition: transform var(--motion-med) var(--motion-ease);\n}\n\n.interactive-lift:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 14px 28px var(--shadow-color);\n}\n\n.interactive-lift:hover::before {\n  transform: scaleY(1);\n}\n\n.btn-shimmer {\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-shimmer::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -120%;\n  width: 70%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.35), transparent);\n  transform: skewX(-18deg);\n}\n\n.btn-shimmer.is-shimmering::after {\n  animation: btnShimmerPass 1.1s var(--motion-ease) 1;\n}\n\n@keyframes btnShimmerPass {\n  to {\n    left: 140%;\n  }\n}\n\n@keyframes floatSoft {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-7px);\n  }\n}\n\n@keyframes pulseSoft {\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes goldPulse {\n  0% {\n    transform: scale(0.96);\n    text-shadow: 0 0 0 rgba(212, 175, 55, 0);\n  }\n  40% {\n    transform: scale(1.05);\n    text-shadow: 0 0 18px rgba(212, 175, 55, 0.45);\n  }\n  100% {\n    transform: scale(1);\n    text-shadow: 0 0 0 rgba(212, 175, 55, 0);\n  }\n}\n\n@keyframes waveDrift {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@keyframes underlineGrow {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n\n  .scroll-reveal,\n  .stagger-item,\n  .interactive-lift,\n  .btn-shimmer::after {\n    transition: none !important;\n    animation: none !important;\n  }\n\n  .scroll-reveal,\n  .stagger-item {\n    opacity: 1 !important;\n    transform: none !important;\n  }\n\n  .btn-shimmer.is-shimmering::after,\n  .hero-waves,\n  .flip-card-icon,\n  .flip-card-hint,\n  .country-list-dot {\n    animation: none !important;\n  }\n}\n\n/* Responsive - التصميم المتجاوب */\n@media (max-width: 768px) {\n  h1 {\n    font-size: 2rem;\n  }\n\n  h2 {\n    font-size: 1.75rem;\n  }\n\n  .section-title {\n    font-size: 2rem;\n  }\n\n  .container {\n    padding: 0 15px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
